import {
  abweichenderRechnungsempfaengerSchema,
  AdresseFormValue,
  adresseSchema,
  PrivatUnternehmenFormValue,
  privatUnternehmenKontaktdatenSchema,
  RechnungsempfaengerFormValue,
  UnterschriftFormValue,
  VertragspartnerMode,
} from './common-vertragspartner.schema';
import { apply, applyWhenValue, Schema, schema } from '@angular/forms/signals';

export interface BisherigerVertragspartnerFormValue {
  vertragspartnerBekanntheit: 'known' | 'unknown';
  privatUnternehmen: PrivatUnternehmenFormValue;
  adresse: AdresseFormValue | null;
}

export interface BisherigerVertragspartnerStepFormValue extends UnterschriftFormValue {
  rechnungsempfaenger: RechnungsempfaengerFormValue;
  vertragspartner: BisherigerVertragspartnerFormValue;
}

export const bisherigerVertragspartnerSchema = schema<BisherigerVertragspartnerFormValue>(path => {
  apply(path.privatUnternehmen, privatUnternehmenKontaktdatenSchema);
  applyWhenValue(path.adresse, value => value !== null, adresseSchema);
});

export function bisherigerVertragspartnerStepSchema(mode: VertragspartnerMode): Schema<BisherigerVertragspartnerStepFormValue> {
  return schema<BisherigerVertragspartnerStepFormValue>(path => {
    switch (mode) {
      case VertragspartnerMode.BEARBEITBAR:
        apply(path.vertragspartner, bisherigerVertragspartnerSchema);
        break;
      case VertragspartnerMode.ACCOUNT_KUNDE:
        apply(path.rechnungsempfaenger, abweichenderRechnungsempfaengerSchema);
        break;
      case VertragspartnerMode.VERWALTETER_KUNDE:
        break;
    }
  });
}
